<!--
  @component LegacyProjectRedirect — back-compat for old /projects/:id[/:section]
  links (and the magic-link returnUrl). Redirects into the new
  /deployments/<section>?p=<id> route space (the ?p= sets the scope to that one
  project). Replaces history so the legacy URL doesn't linger. Renders nothing.
-->
<script lang="ts">
  import { replace } from "svelte-spa-router";

  let { params }: { params?: { id?: string; section?: string } } = $props();

  // Old section names → new section ids.
  const ALIAS: Record<string, string> = {
    deployments: "releases",
    data: "storage",
    domains: "domain",
    settings: "overview",
  };

  $effect(() => {
    const id = params?.id;
    if (!id) { replace("/projects"); return; }
    const raw = params?.section ?? "overview";
    const section = ALIAS[raw] ?? raw;
    replace(`/deployments/${section}?p=${encodeURIComponent(id)}`);
  });
</script>
